import { translateKeys } from './translateKeys';

export type CamelCase<TString extends string> = TString extends `${infer P1}_${infer P2}${infer P3}`
  ? `${Lowercase<P1>}${Uppercase<P2>}${CamelCase<P3>}`
  : Lowercase<TString>;

export type DeepCamelCase<TObje> = {
  // eslint-disable-next-line @typescript-eslint/ban-types
  [K in keyof TObje as CamelCase<string & K>]: TObje[K] extends {} ? DeepCamelCase<TObje[K]> : TObje[K];
};

/**
 *  Convert a string from snake_case to camelCase
 */
export const camelCase = <TString extends string>(snakeCasedString: TString) =>
  snakeCasedString.replace(/([-_]\w)/g, g => g[1]!.toUpperCase()) as CamelCase<TString>;

/**
 * Recursively convert all keys in an object from snake_case to camelCase
 */
export const deepCamelCase = <TReturn = unknown>(objWithSnakeCaseKeys: any) =>
  translateKeys(camelCase, objWithSnakeCaseKeys) as TReturn;
